<template>
  <div>
    <CTabs :active-tab="activeTab">
      <CTab title="ユーザの詳細" :to="{ name: 'ユーザの詳細', params: { id: id } }">
        <router-view />
      </CTab>
      <CTab title="ユーザが所属する薬局一覧" :to="{ name: 'ユーザの薬局一覧', params: { id: id } }">
        <router-view />
      </CTab>
    </CTabs>
  </div>
</template>

<script>
export default {
  name: "UserTabs",
  data() {
    return {
      id: null,
      fields: ["id", "name", "micode", "created_at", "actions"],
    };
  },
  computed: {
    activeTab() {
      return ["ユーザの詳細", "ユーザの薬局一覧"].indexOf(this.$route.name);
    },
  },
  created() {
    this.id = this.$route.params.id;
  },
};
</script>
